export default "__VITE_ASSET__DtgZj4NN__"